import IntelligenceLanding from "@/components/landing/IntelligenceLanding";
import { HeartHandshake, BarChart3, FileSearch, Building2 } from "lucide-react";

export default function ForFunders() {
  return (
    <IntelligenceLanding
      audience="funders"
      eyebrow="For Funders & Foundations"
      title="See where your dollars actually land."
      subtitle="Alabama-specific intelligence on funder activity, grantee readiness, and community demand — so your portfolio decisions hold up in the boardroom."
      bullets={[
        {
          icon: BarChart3,
          title: "Portfolio intelligence",
          body: "County-level dashboards on grant flows, gaps, and concentration risk across Alabama focus areas.",
        },
        {
          icon: FileSearch,
          title: "Quarterly briefings",
          body: "AI-drafted, human-edited reports on what's working, what's stuck, and where unmet demand is forming.",
        },
        {
          icon: HeartHandshake,
          title: "Grantee readiness signals",
          body: "Anonymized signals on coached organizations, projects in motion, and pipeline maturity — without surveys.",
        },
        {
          icon: Building2,
          title: "Sector deep-dives",
          body: "Custom briefs on Health & Wellness, Community, Education, and the funding ecosystems around them.",
        },
      ]}
      pricingNote="Intelligence tier — $2,500/mo. Annual discount available."
    />
  );
}